<!-- Keymap Style Form -->
@if (keymapStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="keymapStyleForm"
    class="w-full"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.text">
      </h4>
      <!-- Color -->
      <medsurf-design-form-control-input-color-picker [control]="keymapStyleForm.controls.color"
        [class]="'w-full'"
        [label]="'global.text_color'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <!-- Font Size -->
      <medsurf-design-form-control-input-dropdown [hidden]="(keymapStyleForm.value.fontSize || 0) > 20"
        [control]="keymapStyleForm.controls.fontSize"
        [class]="'w-full'"
        [options]="FlatModels.KeymapStyleEntityModels.FontSizeArray"
        [label]="'global.font_size'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
      <medsurf-design-form-control-input-number [hidden]="(keymapStyleForm.value.fontSize || 0) <= 20"
        [control]="keymapStyleForm.controls.fontSize"
        [class]="'w-full'"
        [min]="20"
        [label]="'global.font_size'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
    </div>
  </medsurf-design-form-control-form>
}